import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const HomePlaceholderIcon = (props: IconProps) => (
  <Icon width="242px" height="240px" viewBox="0 0 242 240" {...props}>
    <circle cx="121.91" cy="120.357" r="115.357" fill="#F5F5F5" opacity=".38" />
    <mask
      id="a"
      width="14"
      height="13"
      x="184"
      y="132"
      maskUnits="userSpaceOnUse"
    >
      <rect
        width="12.8571"
        height="12.1429"
        fill="#D9D9D9"
        transform="matrix(-1 0 0 1 197.267 132.857)"
      />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#FFF4E5"
        fillRule="evenodd"
        d="M200.41 166.429h-35.286v-33.572h35.286c-8.837 0-16 7.164-16 16v1.572c0 8.836 7.163 16 16 16Z"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#FFF4E5"
      d="M184.41 132.857H20.9813c-4.4182 0-7.9999 3.582-7.9999 8V162c0 4.418 3.5817 8 8 8H176.41c4.418 0 8-3.582 8-8v-29.143Z"
    />
    <line
      x1="2"
      x2="146.571"
      y1="-2"
      y2="-2"
      stroke="#FFD599"
      strokeLinecap="round"
      strokeWidth="4"
      transform="matrix(-1 0 0 1 172.981 145)"
    />
    <line
      x1="2"
      x2="146.571"
      y1="-2"
      y2="-2"
      stroke="#FFD599"
      strokeLinecap="round"
      strokeWidth="4"
      transform="matrix(-1 0 0 1 172.981 152.143)"
    />
    <line
      x1="2"
      x2="98"
      y1="-2"
      y2="-2"
      stroke="#FFD599"
      strokeLinecap="round"
      strokeWidth="4"
      transform="matrix(-1 0 0 1 172.981 160)"
    />
    <circle cx="40.1242" cy="166.429" r="8.57143" fill="#FFD599" />
    <g clipPath="url(#b)">
      <path
        fill="#fff"
        d="M35.541 170.179h1.6667v-5H35.541v5Zm9.1667-4.584c0-.458-.375-.833-.8334-.833h-2.6291l.3958-1.904.0125-.133c0-.171-.0708-.33-.1833-.442l-.4417-.438-2.7417 2.746c-.1541.15-.2458.359-.2458.588v4.166c0 .459.375.834.8333.834h3.75c.3459 0 .6417-.209.7667-.509l1.2583-2.937c.0375-.096.0584-.196.0584-.304v-.834Z"
      />
    </g>
    <rect
      width="36.4286"
      height="12.8571"
      x="189.41"
      y="40"
      fill="#E5F2FF"
      rx="6.42857"
    />
    <circle cx="196.553" cy="46.4286" r="2.14286" fill="#99CAFF" />
    <ellipse
      cx="203.696"
      cy="46.4286"
      fill="#99CAFF"
      rx="2.14285"
      ry="2.14286"
    />
    <ellipse
      cx="210.838"
      cy="46.4286"
      fill="#99CAFF"
      rx="2.14285"
      ry="2.14286"
    />
    <circle cx="217.981" cy="46.4286" r="2.14286" fill="#99CAFF" />
    <rect
      width="36.4286"
      height="12.8571"
      x="17.9812"
      y="189.286"
      fill="#FFF4E5"
      rx="6.42857"
    />
    <circle cx="25.1241" cy="195.714" r="2.14286" fill="#FFD599" />
    <circle cx="32.2669" cy="195.714" r="2.14286" fill="#FFD599" />
    <circle cx="39.4097" cy="195.714" r="2.14286" fill="#FFD599" />
    <circle cx="46.5525" cy="195.714" r="2.14286" fill="#FFD599" />
    <mask
      id="c"
      width="14"
      height="13"
      x="44"
      y="64"
      maskUnits="userSpaceOnUse"
    >
      <rect
        width="12.8571"
        height="12.1429"
        x="44.4099"
        y="64.2858"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#c)">
      <path
        fill="#F2F8FF"
        fillRule="evenodd"
        d="M41.2671 97.8572h35.2857V64.2858H41.2671c8.8365 0 16 7.1634 16 16v1.5714c0 8.8365-7.1635 16-16 16Z"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#F2F8FF"
      d="M57.2671 64.2858H220.696c4.418 0 8 3.5817 8 8v21.1428c0 4.4183-3.582 8.0004-8 8.0004H65.2671c-4.4183 0-8-3.5821-8-8.0004V64.2858Z"
    />
    <line
      x1="70.6956"
      x2="145.267"
      y1="74.4287"
      y2="74.4287"
      stroke="#CCE4FF"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <line
      x1="154.981"
      x2="214.553"
      y1="74.4287"
      y2="74.4287"
      stroke="#CCE4FF"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <line
      x1="70.6956"
      x2="215.267"
      y1="81.5715"
      y2="81.5715"
      stroke="#CCE4FF"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <line
      x1="70.6956"
      x2="105.267"
      y1="89.4287"
      y2="89.4287"
      stroke="#CCE4FF"
      strokeLinecap="round"
      strokeWidth="4"
    />
    <mask id="d" width="46" height="47" x="0" y="68" maskUnits="userSpaceOnUse">
      <circle cx="22.9814" cy="91.4287" r="22.8571" fill="#E5F2FF" />
    </mask>
    <g mask="url(#d)">
      <rect
        width="67.2653"
        height="142.367"
        fill="#E5F2FF"
        transform="translate(-10.9778 64.6531)"
      />
      <g clipPath="url(#e)">
        <path
          fill="#fff"
          d="M15.1274 102.565s-7.18754 4.884-9.2597 25.896c-1.45281 14.719-2.70681 19.892-2.70681 19.892l4.23608.061s8.28103-20.616 9.03033-29.766c.3518-4.319-1.2999-16.075-1.2999-16.075v-.008ZM30.5961 102.375s8.3422 3.245 10.1696 25.492c1.2082 14.734 2.4545 20.486 2.4545 20.486l-4.2361.061s-8.281-20.616-9.0303-29.766c-.3518-4.32.6499-16.273.6499-16.273h-.0076Z"
        />
        <path
          fill="#fff"
          d="M20.671 100.806c-2.7068.167-5.6889.64-6.5223 3.458-.5582 3.84 1.2846 16.114-1.0476 28.669-3.28025 17.676-2.5768 36.829-2.5768 36.829l25.8676.19s.3288-19.336-2.3244-36.828c-1.7969-11.84-.3059-23.527-1.9804-28.867-.8794-2.811-5.1078-3.086-6.5453-3.451-1.7358-.724-2.5692-.145-4.8708 0Z"
        />
        <path
          fill="#323232"
          d="M39.1293 84.2654c0 8.9442-7.2794 16.1976-16.2562 16.1976S6.61694 93.2096 6.61694 84.2654c0-8.9443 7.27936-16.1973 16.25616-16.1973s16.2562 7.253 16.2562 16.1973Z"
        />
        <path
          fill="#323232"
          d="M17.9566 91.0384s-.6117-3.3674.4741-5.4473c1.361-2.6132 5.4213-4.0531 8.5486-1.2723 2.1792 1.9351 1.0323 7.0472 1.0323 7.0472l-6.8206-2.8874-3.2344 2.5522v.0076Z"
        />
        <path
          fill="#29374F"
          d="M25.5419 100.805s-2.8598 1.509-4.8708 0l.4282-5.2259h4.0144l.4282 5.2259ZM18.813 90.4517s-.5735-.3733-1.0246.2209c-.4435.5943-.1453 2.8113.9634 2.8113 1.1088 0 .0536-3.0322.0536-3.0322h.0076ZM27.4305 90.4517s.5734-.3733 1.0246.2209c.4435.5943.1529 2.8113-.9635 2.8113-1.1163 0-.0535-3.0322-.0535-3.0322h-.0076Z"
        />
        <path
          fill="#2F3D5B"
          d="M27.6141 89.8346c0-2.4913-2.0187-4.1217-4.5114-4.1217s-4.5113 1.6304-4.5113 4.1217c0 0-.1988 3.177-.1988 3.3369 0 2.3694 2.9132 5.3712 4.7101 5.3712 2.0798 0 4.7102-3.5808 4.7102-5.3712 0-.1523-.1988-3.3369-.1988-3.3369Z"
        />
        <path
          fill="#fff"
          d="M18.7137 94.8705s.0612-.0152.0917-.0305l-.107-.259s-.0382.0152-.0535.0152c-.497.1372-1.017-.1599-1.1546-.6628-.1377-.4952.1605-1.0133.6652-1.1504l-.0688-.2666c-.65.1752-1.0399.8456-.8641 1.4856.1759.6476.8488 1.0285 1.4987.8609l-.0076.0076ZM27.4459 94.8705s-.0688-.0229-.107-.0381c.0306.0076.1147-.2514.1147-.2514.0229 0 .0458.0152.0611.0228.497.1372 1.017-.16 1.1546-.6628.1377-.4952-.1605-1.0133-.6652-1.1504l.0688-.2667c.65.1753 1.0323.8457.8641 1.4857-.1759.6475-.8488 1.0285-1.4987.8609h.0076Z"
        />
      </g>
    </g>
    <mask
      id="f"
      width="47"
      height="46"
      x="195"
      y="134"
      maskUnits="userSpaceOnUse"
    >
      <circle cx="218.696" cy="157.143" r="22.8571" fill="#FFFAE5" />
    </mask>
    <g clipPath="url(#g)" mask="url(#f)">
      <rect
        width="101.225"
        height="139.102"
        fill="#FFFAE5"
        transform="translate(142.94 131.02)"
      />
      <path
        fill="#FFEACC"
        d="M217.632 143.024c-3.695.036-8.293 1.998-7.753 8.081.377 4.263 1.404 11.557 4.207 11.784 1.24.1 5.489-1.448 5.489-1.448l.356 5.092 7.972-2.103-3.129-6.601s5.031-14.922-7.142-14.802v-.003Z"
      />
      <path
        fill="#323232"
        d="m211.131 145.557 7.259 6.335c.472-1.988 1.993-1.898 3.1-.683 1.363 1.496-.297 3.521.049 4.055.348.531 2.761 2.617 3.229 2.562.471-.055 8.095-6.29 1.504-15.184-3.038-4.101-11.34-3.628-15.144 2.915h.003Z"
      />
      <path
        fill="#323232"
        d="M214.754 136.352c.084 2.924 1.957 4.696 4.612 4.622 2.651-.075 3.807-2.022 3.726-4.946-.084-2.925-1.544-5.082-4.198-5.008-2.654.075-4.224 2.404-4.14 5.328v.004Z"
      />
      <path
        fill="#fff"
        d="M220.751 168.793c-5.009.431-6.271 12.5-.782 34.522l-20.927 7.482 3.497 3.592s21.715-.69 25.283-8.658c3.568-7.968 2.164-37.731-7.071-36.938Z"
      />
      <path
        fill="#fff"
        d="m217.686 163.87 25.448-6.254s5.17 16.169-7.639 16.923c-12.807.758-17.805-10.669-17.805-10.669h-.004Z"
      />
      <path
        fill="#fff"
        d="M224.635 163.06c3.662.227 7.259 1.118 9.62 8.049 3.364 9.549 5.744 26.188 5.831 57.765l-29.868-11.21c3.077-16.183 1.821-48.605 7.468-53.791 2.348-.991 3.84-1.004 6.949-.809v-.004Z"
      />
      <path
        fill="#fff"
        d="M226.366 169.95c-5.024.013-6.271 12.499-.781 34.521l-17.228 5.801-.203 5.276s21.715-.084 25.284-8.052c3.568-7.968-1.253-37.556-7.072-37.543v-.003Z"
      />
    </g>
    <defs>
      <clipPath id="b">
        <rect
          width="10"
          height="10"
          fill="#fff"
          transform="translate(35.1243 161.429)"
        />
      </clipPath>
      <clipPath id="e">
        <rect
          width="40.0593"
          height="138.827"
          fill="#fff"
          transform="translate(3.16089 68.0681)"
        />
      </clipPath>
      <clipPath id="g">
        <rect
          width="101.225"
          height="139.102"
          fill="#fff"
          transform="translate(142.94 131.02)"
        />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(HomePlaceholderIcon);
